import { diffCalendarDaysYmd } from '../utils/taskEarlySubmit';

/** True when expiry badge label omits the YYYY-MM-DD date (hover/tap hint should show it). */
export const inventoryV2ExpiryBadgeNeedsDateHint = (todayYmd: string, expiryYmd: string): boolean => {
  const daysUntil = diffCalendarDaysYmd(todayYmd, expiryYmd);
  return daysUntil < 30;
};
